module.exports = {
  Project: {
    api: 'https://staging-api.hoxtonmix.com/api/v3/',
    appStore: 'https://apps.apple.com/gb/app/hoxton-mix/id6449089524',
    auth: {
      cognito: true,
    },
    //https://checkout.hoxtonmix.com
    chargbeeSite: 'hoxtonmix-test',
    chargebeeUrl: 'https://hoxtonmix-test.chargebee.com',
    cognito: {
      oauth: {
        domain: 'ssg-boilerplate.auth.eu-west-2.amazoncognito.com',
        // optional, for Cognito hosted ui specified options
        options: {
          // Indicates if the data collection is enabled to support Cognito advanced security features. By default, this flag is set to true.
          // AdvancedSecurityDataCollectionFlag: true
        },
        redirectSignIn: 'http://localhost:3000',
        redirectSignOut: 'http://localhost:3000',
        responseType: 'code',
        scope: ['profile', 'email', 'openid'],
      },
      region: 'eu-west',
      userPoolId: 'eu-west-2_uvQbrAUmt',
      userPoolWebClientId: 'gvjqjukmm1e2b1mrhpebeumte',
    },
    dataRelayKonnect: '47d9-ffe5-1414',
    //https://checkout.hoxtonmix.com
    debug: false,
    flags: {
      go_cardless: true,
      market_place: true,
      related_offers: true,
    },
    flagsmith: 'KKhg4XaMLNYPFSdNnkkXtT',
    gtm: false,
    imageProxy: 'https://imgproxy.hoxtonmix.com/',
    logs: {
      ANALYTICS: true,
      API: false,
      STORAGE: false,
    },
    loqate: 'PR28-BF96-PB24-GY46',
    paypal:
      'ARLU1HFkZQXD_swGtgbR2tN7f-bFYoyYlPUL69PmwHFOioelEiSh-NxichfQuPCj05UoNAeUE0Ptz-xB',
    playStore:
      'https://play.google.com/store/apps/details?id=com.hoxtonmix.portal',
    portalURL: 'https://staging-account.hoxtonmix.com/',
    season: {
      christmas: false,
      easter: false,
    },
    sentry:
      'https://36ba2215354e4e0e90e43595574de811@o31090.ingest.sentry.io/4504441225543680',
    sentryEnvironment: 'development',
    stripe: 'pk_test_CvegxsaywY0KQ1iu62m08PQx',
    // AU tenant's Stripe account (backend uses STRIPE_API_KEY_AU)
    stripeAu:
      'pk_test_51QPYouEzAx9JltnudoVIyr4OY8SWD1AKKiTOWXIKsFbyg9QmgdJMAFU3i8FUpx9aAHd8etw30P3skKGAGkeT7COE001YvGOyuk',
    testCafeStage: 'staging',
  },
}
